var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 2C11.5401 2 11.167 2.3731 11.167 2.83333V11.1666H2.83333C2.3731 11.1666 2 11.5397 2 12C2 12.4602 2.3731 12.8333 2.83333 12.8333H11.167V21.1667C11.167 21.6269 11.5401 22 12.0003 22C12.4606 22 12.8337 21.6269 12.8337 21.1667V12.8333H21.1667C21.6269 12.8333 22 12.4602 22 12C22 11.5397 21.6269 11.1666 21.1667 11.1666H12.8337V2.83333C12.8337 2.3731 12.4606 2 12.0003 2Z",
    fill: "#F89521"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd2);
export default __webpack_public_path__ + "static/media/add-2.b3a0014ee8bc7d914d46b8ac1bc673d5.svg";
export { ForwardRef as ReactComponent };